import { render } from "./PatientDetail.vue?vue&type=template&id=9710cf4a&scoped=true"
import script from "./PatientDetail.vue?vue&type=script&lang=js"
export * from "./PatientDetail.vue?vue&type=script&lang=js"

import "./PatientDetail.vue?vue&type=style&index=0&id=9710cf4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9710cf4a"]])

export default __exports__